import PackingDetailsTable from "./PackingDetailsTable";
export default PackingDetailsTable;
